import { usePyodide } from '@playground/SQL/hooks/usePyodide';

export const useActiveCode = (): {
  code: string;
  readOnly: boolean;
  updateCode: (newCode: string) => void;
  activeFile: string;
} => {
  const { pyodide } = usePyodide();

  return {
    code: pyodide.files[pyodide.activeFile]?.code,
    readOnly: pyodide.files[pyodide.activeFile]?.readOnly ?? false,
    updateCode: pyodide.updateCurrentFile,
    activeFile: pyodide.activeFile,
  };
};
